import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const BookmarkIcon: FC<
  IconProps & {
    startColor?: string;
    endColor?: string;
    active?: boolean;
  }
> = memo(
  ({
    width,
    height,
    size = 44,
    color,
    active,
    startColor,
    endColor,
    style,
  }) => {
    if (active) {
      return (
        <Svg
          width={width ?? size}
          height={height ?? size}
          viewBox="0 0 1024 1024"
          fill="none"
        >
          <Path
            d="M811.446857 73.142857q13.165714 0 25.161143 5.12 18.870857 7.460571 29.988571 23.405714t11.117714 35.401143l0 736.548571q0 19.456-11.117714 35.401143t-29.988571 23.405714q-10.825143 4.534857-25.161143 4.534857-27.428571 0-47.396571-18.285714l-251.977143-242.322286-251.977143 242.322286q-20.553143 18.870857-47.396571 18.870857-13.165714 0-25.161143-5.12-18.870857-7.460571-29.988571-23.405714t-11.117714-35.401143l0-736.548571q0-19.456 11.117714-35.401143t29.988571-23.405714q11.995429-5.12 25.161143-5.12l598.820571 0z"
            fill="url(#paint0_linear_409_2680)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_409_2680"
              x1="0"
              y1="811.446857"
              x2="0"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor={startColor ?? color} />
              <Stop offset="1" stopColor={endColor ?? color} />
            </LinearGradient>
          </Defs>
        </Svg>
      );
    }

    return (
      <Svg
        width={width ?? size ?? 31}
        height={height ?? size ?? 32}
        viewBox="0 0 1024 1024"
        fill="none"
        style={style}
      >
        <Path
          d="M804.571 146.286H219.43V855.99L512 575.415l50.834 48.567L804.571 855.99V146.286z m6.876-73.143q13.166 0 25.161 5.12 18.87 7.46 29.989 23.406t11.117 35.4v736.55q0 19.455-11.117 35.4t-29.989 23.406q-10.825 4.535-25.161 4.535-27.429 0-47.397-18.286L512.073 676.352 260.096 918.674q-20.553 18.871-47.397 18.871-13.165 0-25.16-5.12-18.872-7.46-29.99-23.406t-11.117-35.4v-736.55q0-19.455 11.118-35.4t29.988-23.406q11.996-5.12 25.161-5.12H811.52z"
          fill={color ?? 'rgba(255, 255, 255, 0.6)'}
        />
      </Svg>
    );
  },
);
